<template>
  <span           
    v-tippy
    content="Reset to default value" :class="$style.root" class="cursor-pointer" v-on="$listeners">
    <span :class="$style.circle" />
    <Icon :class="$style.cancel" name="times" />
</span>
</template>

<script>

import Icon from '../Icon'

export default {
  components: { Icon },

  name: 'ChangeIndicator'
}

</script>

<style module>

.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  line-height: 16px;
  vertical-align: middle;
}

.circle {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;

  @apply bg-primary;
}

.root:hover .circle {
  display: none;
}

.cancel {
  /* fontawesome .far class applies display: inline-block */
  display: none !important;
  font-size: 8px;
}

.root:hover .cancel {
  display: inline-block !important;
}

</style>
